import styled from 'styled-components'
// import colors from '@settings/styleSettings'

export const ActivityContainer = styled.div`
    width: 90%;
    height: 80%;
    display: flex;
    flex-direction: column;
    padding: 20px;

`

export const ArrowBackContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;
    margin-bottom: 20px;

`
export const ArrowBackTextContainer = styled.div`
   h1{
         margin-bottom: 0;
   }

    p{
        margin-top: 5px;
        opacity: 0.5;
    }

`
export const Row = styled.div`
    display: flex;
    gap: 20px;
    align-items: center;
    margin-bottom: 20px;
    height: 80vh;
`

export const Column = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-bottom: 20px;
    justify-content: space-between;
    
`
